var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6001 3.99999C1.6001 3.57565 1.76867 3.16868 2.06873 2.86862C2.36878 2.56856 2.77575 2.39999 3.2001 2.39999H9.6001C10.0244 2.39999 10.4314 2.56856 10.7315 2.86862C11.0315 3.16868 11.2001 3.57565 11.2001 3.99999V12C11.2001 12.4243 11.3687 12.8313 11.6687 13.1314C11.9688 13.4314 12.3758 13.6 12.8001 13.6H3.2001C2.77575 13.6 2.36878 13.4314 2.06873 13.1314C1.76867 12.8313 1.6001 12.4243 1.6001 12V3.99999ZM4.0001 4.79999H8.8001V7.99999H4.0001V4.79999ZM8.8001 9.59999H4.0001V11.2H8.8001V9.59999Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.60001H12.8C13.2243 5.60001 13.6313 5.76858 13.9314 6.06864C14.2314 6.36869 14.4 6.77566 14.4 7.20001V11.6C14.4 11.9183 14.2736 12.2235 14.0485 12.4485C13.8235 12.6736 13.5183 12.8 13.2 12.8C12.8817 12.8 12.5765 12.6736 12.3515 12.4485C12.1264 12.2235 12 11.9183 12 11.6V5.60001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/Newspaper.db81c7fabfa4abb3b04d7ab6bce5c25c.svg";
export { ForwardRef as ReactComponent };